import { Card } from "../../../components/Card";
import { PerformanceView } from "../../praxis-call/components/PerformanceView";
import { filteredFastReportsMetrics } from "../../praxis-call/components/report-tabs/Performance";
import { useApp } from "../../../services/app-context";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../../services/api";
import { LottieLoading } from "../../../components/Loading/LottieLoading";
import { useMemo } from "react";

export function CallInsights() {
    const { tenantProfile } = useApp();
    const metric_exclusions = tenantProfile?.metric_exclusions || {};
    const dashboardsMetricExclusions = useMemo(() => {
        const newObj: any = {};
        Object.keys(metric_exclusions?.dashboards || {}).forEach((key) => {
          newObj[key.toLowerCase()] = metric_exclusions?.dashboards?.[key];
        });
        return newObj;
      }, [metric_exclusions?.dashboards]);
    const {
        data: insightsData,
        isLoading: isLoadingInsights,
        refetch: refetchInsights,
    } = useQuery({
        queryKey: ["metrics-insights"],
        queryFn: () => api.getInsights(),
    });

    const insights = insightsData?.data?.insights || [];
    return (
        <Card className="h-full !px-0 !py-[18px]">
            <div className="px-[18px] mb-4 text-[clamp(13px,1.5vw,16px)] font-semibold text-text-primary">
                Overall Core Competency Insights
            </div>
            <div className="px-[18px] flex flex-col gap-2.5">
                {isLoadingInsights ? <LottieLoading className="!w-full !h-[100px]" /> : (
                    filteredFastReportsMetrics(insights, dashboardsMetricExclusions).map((metric) => (
                        <PerformanceView
                            key={metric?.key}
                            title={metric?.name}
                            value={metric?.value || 0}
                            titleClassName="!text-[clamp(11px,1.5vw,13px)]"
                        />
                    )
                    ))}
            </div>
        </Card>
    );
}